let debounceTimer

export default function debounceHelper(func, delay = 1000, args = [], runBefore = false) {
  if (runBefore) {
    func()
  }
  clearTimeout(debounceTimer)
  const setTimeoutArgs = args.length > 0 ? [func, delay, ...args] : [func, delay]
  debounceTimer = setTimeout(...setTimeoutArgs)
}
